import { isNotNull } from '@ramp106/omrjs-common'

export const PRODUCT_SEGMENTS = 2
export const TOPIC_SEGMENTS = 3

export const categoryPrefixAt = (category: string, segments: number): string | null => {
  const parts = category.split('.')
  if (parts.length < segments) return null
  return parts.slice(0, segments).join('.')
}

export const categoryPrefixes = (categories: string[], segments: number): string[] =>
  [...new Set(categories.map((category) => categoryPrefixAt(category, segments)).filter(isNotNull))].sort()

export const categoriesUnder = (categories: string[], prefix: string | null): string[] =>
  prefix ? categories.filter((category) => category === prefix || category.startsWith(`${prefix}.`)) : categories

export const categoryPrefixOfDepth = (value: string | null, segments: number): string | null => {
  if (!value) return null
  const parts = value.split('.')
  return parts.length === segments && parts.every(Boolean) ? value : null
}

export const categoryPrefixFallbackLabel = (prefix: string): string => {
  const segment = prefix.split('.').filter(Boolean).pop() || prefix
  const spaced = segment.replace(/_/g, ' ')
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}
